module.exports = __webpack_public_path__ + "img/icon-basePar-1.c17f4c7d.png";